import { Controller } from "@hotwired/stimulus"

// Opens a partner's detail modal from whatever named it — a row in a "Where to
// spend" list, a card in the club map's strip, a card in the creator's picker.
//
// The modals cannot live inside the list that points at them: the map view
// hides that list with `display:none`, which would take its descendants —
// including whatever a row wanted to open — down with it. So they sit as
// siblings of the list, and every entry point finds one by id instead.
//
// Its own controller rather than a method on partners-view, because the picker
// on /brunches wants this and nothing else about that map/list toggle.
export default class extends Controller {
  open(event) { this.openPartner(event.currentTarget.dataset.partnerId) }
  // A pin tapped on a creator's map (partners-map:select, 28 Oct 2026): the
  // place's sheet, as its row would open it.
  fromMap(event) { this.openPartner(event.detail.id) }

  openPartner(id) {
    const modal = this.element.querySelector(
      `[data-partner-modal-id="${CSS.escape(id)}"]`)
    if (!modal) return
    this.application
      .getControllerForElementAndIdentifier(modal, "partner-modal")
      ?.open()
  }
}
